export var getInclinedWord = function getInclinedWord(count, wordsVariations) {
  if (count > 0) {
    var options = [2, 0, 1, 1, 1, 2];
    return wordsVariations[count % 100 > 4 && count % 100 < 20 ? 2 : options[count % 10 < 5 ? count % 10 : 5]];
  }
  return wordsVariations[1];
};